'use strict';

var App = require('app');
var AppState = require('app_state');
var CommonViews = require('components/common/views');
var DeviceFilterView = require('components/devices/views/common/device_filter_view');
var DeviceSelection = require('utils/device_selection');
var StatsValueView = require('components/devices/views/tools/stats/stats_value_view');
var StatsDeviceSelectView = require('components/devices/views/tools/stats/stats_device_select_view');
var I18N = require('utils/i18n');
var Misc = require('utils/misc');

var StatsView = Marionette.LayoutView.extend({
    template: require('components/devices/templates/tools/stats/stats'),

    regions: {
        deviceFilter: '#device-filter',
        deviceSelect: '#device-select',
        deviceSelectError: '#device-select-error',
        valueList: '#value-list',
    },

    events: {
        'click .js-stats-add': 'addValue',
        'click .js-stats-refresh': 'refresh',
        'click .js-stats-save-perm': 'saveVirtualDevice',
    },

    initialize: function () {
        this.controller = this.options.controller;
        this.userConfig = AppState.getStatsConfig();
        this.data = {
            filter: this.options.filter || this.userConfig.filter || {},
            series: this.options.series || this.userConfig.series || [],
        };
        this.backgroundTasks = Misc.getBackgroundTaskManager();
        this.createFilter();
    },

    serializeData: function () {
        var data = Marionette.LayoutView.prototype.serializeData.apply(this);
        data.hasColumns = AppState.availableColumns().length > 0;
        return data;
    },

    refresh: function (e) {
        var self = this;

        var isFilterType = (this.data.filter.category || []).length;
        var isFilterTypeCombined = Misc.isFilterTypeCombined(this.data.filter.category);
        this.canEdit = isFilterType && !isFilterTypeCombined;

        Misc.setVisible('.js-stats-info-select-cat', !isFilterType);
        Misc.setVisible('.js-stats-info-combine-cat', isFilterTypeCombined);
        Misc.setVisible('.js-stats-info', !isFilterType || isFilterTypeCombined);

        Misc.setDisabled('.js-stats-save-perm', !isFilterType || isFilterTypeCombined);

        this.selectionCtx = undefined;
        this.recalculate(Boolean(e));
        this.backgroundTasks.done(function () {
            self.displayDeviceList();
        });
    },

    createFilter: function () {
        var self = this;
        this.filterView = new DeviceFilterView({
            controller: this.controller,
            onLoadComplete: function () {
                if (self.options.onLoadComplete) self.options.onLoadComplete();
                self.showChildView('deviceFilter', self.filterView);
                if (Misc.isFilterEmpty(self.data.filter)) {
                    self.refresh();
                }
            },
            onFilterChanged: function () {
                self.deviceSelectError.empty();
                self.data.filter = self.filterView.getFilter();
                self.data.useSelected = false;
                self.saveSettings();
                self.controller.setFilter(self.data.filter);
                self.refresh();
            },
            defaultFilter: this.data.filter,
            showDeviceCount: true,
        });
    },

    showResultData: function () {
        // destroy current 'valueList'-view (if required)
        var vlView = this.getChildView('valueList');
        if (vlView) {
            vlView.destroy();
        }

        var self = this;
        AppState.requireColumns(function () {
            // no columns at all? show an error
            if (!AppState.availableColumns().length) {
                vlView = new CommonViews.Message({
                    text: I18N.TR('Keine Werte zur Anzeige verfügbar.'),
                    title: I18N.TR('Hinweis'),
                });
            }
            // .. and replace
            else if (self.data.series === undefined || self.data.series.length == 0) {
                // no results? -> show message
                vlView = new CommonViews.Alert({
                    type: 'info',
                    fullWidth: true,
                    text: I18N.TR('Keine Werte zur Anzeige ausgewählt.'),
                    additionalHtml:
                        ' <a href="" class="js-stats-add">' +
                        I18N.TR('Klicken Sie hier oder auf den Plus-Button.') +
                        '</a>',
                });
            } else {
                // results available -> show value list
                vlView = new Marionette.CollectionView({
                    collection: new Backbone.Collection(self.data.series),
                    controller: self.controller,
                    childView: StatsValueView,
                    childViewOptions: {
                        controller: self.controller,
                        data: self.data,
                        updateCallback: function (skipRecalc) {
                            self.triggerUpdateConfiguration(skipRecalc);
                        },
                        canEdit: self.canEdit,
                    },
                });
            }
            self.showChildView('valueList', vlView);
        });
    },

    addValue: function (e) {
        e.preventDefault();

        var self = this;
        this.controller.addEditValue({
            data: this.data,
            cb: function () {
                self.triggerUpdateConfiguration();
            },
        });
    },

    saveSettings: function () {
        this.userConfig = {
            filter: this.data.filter,
            series: this.data.series,
        };

        AppState.saveStatsConfig(this.userConfig);
    },

    triggerUpdateConfiguration: function (skipRecalc) {
        if (!skipRecalc) this.recalculate();
        else this.showResultData();
        this.saveSettings();
    },

    recalculate: function (refresh) {
        var self = this;
        if (this.data.series.length) {
            this.backgroundTasks
                .when(
                    App.request(
                        'statistics:calculate',
                        this.data,
                        self.selectionCtx ? self.selectionCtx.selectionID : 0,
                        refresh
                    )
                )
                .done(function (result) {
                    if (!result) {
                        self.showError('valueList', I18N.TR('Fehler beim Berechnen der Statistik.'));
                        return;
                    }

                    self.showResultData();
                });
        } else {
            this.showResultData();
        }
    },

    showError: function (region, msg) {
        var errView = new CommonViews.Alert({
            type: 'danger',
            fullWidth: true,
            text: msg,
        });

        this.showChildView(region, errView);
    },

    displayDeviceList: function () {
        var self = this;
        this.selectionCtx = undefined;
        var filterParams = $.extend(
            { limit: AppState.getItemsPerPage() || 20 },
            AppState.getURLParameter(['sortCol', 'sortDesc', 'page'])
        );

        this.backgroundTasks
            .when(
                App.request('device:list', {
                    filterParams: filterParams,
                    filter: this.data.filter,
                    cache: true,
                })
            )
            .done(function (list) {
                if (!list) {
                    self.showError('deviceSelectError', I18N.TR('Die Geräteliste konnte nicht geladen werden.'));
                    return;
                }
                self.selectionCtx = new DeviceSelection({
                    filter: self.data.filter,
                    count: list.count,
                    onUpdate: function () {
                        self.recalculate();
                    },
                });
                var view = new StatsDeviceSelectView({
                    selectionCtx: self.selectionCtx,
                    series: self.data.series,
                    itemsPerPage: self.controller.getItemsPerPage(),
                    controller: self.controller,
                    collection: list.items,
                    listResult: list.listResult,
                    itemCount: list.count,
                    isSummaryView: true,
                });

                self.showChildView('deviceSelect', view);
                self.filterView.setDeviceCount(list.count);
            });
    },

    saveVirtualDevice: function () {
        this.controller.saveVirtualDevice(this.data, this.selectionCtx.selectionID);
    },
});

module.exports = StatsView;
